package fr.frux.feature.notifications

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [NotificationsViewModel], honoré par le composition root (#43). */
fun interface NotificationsViewModelFactory {
    fun create(): NotificationsViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalNotificationsViewModelFactory =
    staticCompositionLocalOf<NotificationsViewModelFactory> {
        error(
            "NotificationsViewModelFactory absente : le composition root doit l'installer " +
                "(cf. FruxCompositionRoot, #43)",
        )
    }

@Composable
fun rememberNotificationsViewModel(): NotificationsViewModel {
    val factory = LocalNotificationsViewModelFactory.current
    return viewModel { factory.create() }
}
